import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import { DashboardProvider } from './contexts/DashboardContext'
import Layout from './components/Layout'
import AdminRouteGuard from './components/AdminRouteGuard'
import CustomerRouteGuard from './components/CustomerRouteGuard'
import AgentRouteGuard from './components/AgentRouteGuard'
import Landing from './pages/Landing'
import Login from './pages/Login'
import AdminLogin from './pages/AdminLogin'
import AdminSignup from './pages/AdminSignup'
import Register from './pages/Register'
import SignIn from './pages/SignIn'
import OTPVerification from './pages/OTPVerification'
import ForgotPassword from './pages/ForgotPassword'
import Dashboard from './pages/Dashboard'
import CustomerDashboard from './pages/CustomerDashboard'
import HandoverAgentConsole from './pages/HandoverAgentConsole'
import Registrations from './pages/Registrations'
import Tenants from './pages/Tenants'
import AdminUsers from './pages/AdminUsers'
import Analytics from './pages/Analytics'
import RagConfig from './pages/RagConfig'
import Settings from './pages/Settings'
import SystemMonitor from './pages/SystemMonitor'
import ReferralApprovals from './pages/ReferralApprovals'
import TrialReminders from './pages/TrialReminders'
import Multilingual from './pages/Multilingual'
import AdminHandover from './pages/AdminHandover'
import Subscribe from './pages/Subscribe'
import { Toaster } from 'react-hot-toast'
// import SelfHealingMonitor from './components/SelfHealingMonitor'

function LogoutPage() {
  const { logout } = useAuth()
  logout()
  return <Navigate to="/" replace />
}

function App() {
  const { user, loading } = useAuth()

  // Debug logging
  console.log('App render - user:', user, 'loading:', loading)
  console.log('Admin token in localStorage:', !!localStorage.getItem('admin_auth_token'))
  console.log('User data in localStorage:', localStorage.getItem('user_data'))

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  return (
    <>
      <Toaster position="top-right" toastOptions={{
        duration: 3000,
        style: { borderRadius: '8px', background: '#333', color: '#fff' }
      }} />
      {/* <SelfHealingMonitor /> */}
      <Routes>
      {/* Public routes - Landing page first */}
      <Route path="/" element={
        !user
          ? <Landing />
          : <Navigate to={
              user.isAdmin
                ? '/dashboard'
                : (user.role === 'handover_agent' ? '/agent-dashboard' : '/customer-dashboard')
            } replace />
      } />
      <Route path="/register" element={<Register />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/verify-email" element={<OTPVerification />} />
      <Route path="/logout" element={<LogoutPage />} />
      
      {/* Auth routes */}
      <Route path="/login" element={
        user
          ? <Navigate to={
              user.isAdmin
                ? '/dashboard'
                : (user.role === 'handover_agent' ? '/agent-dashboard' : '/customer-dashboard')
            } replace />
          : <Login />
      } />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/admin-login" element={
        user
          ? <Navigate to={
              user.isAdmin
                ? '/dashboard'
                : (user.role === 'handover_agent' ? '/agent-dashboard' : '/customer-dashboard')
            } replace />
          : <AdminLogin />
      } />
      <Route path="/admin-signup" element={
        user
          ? <Navigate to={
              user.isAdmin
                ? '/dashboard'
                : (user.role === 'handover_agent' ? '/agent-dashboard' : '/customer-dashboard')
            } replace />
          : <AdminSignup />
      } />
      
      {/* Customer routes - Protected with CustomerRouteGuard */}
      <Route path="/customer-dashboard" element={
        <CustomerRouteGuard>
          <CustomerDashboard />
        </CustomerRouteGuard>
      } />

      {/* Handover-agent sub-user console */}
      <Route path="/agent-dashboard" element={
        <AgentRouteGuard>
          <HandoverAgentConsole />
        </AgentRouteGuard>
      } />

      {/* Legacy redirect for old API keys route - Keep for backwards compatibility */}
      <Route path="/api-keys" element={<Navigate to="/customer-dashboard" replace />} />

      {/* Admin routes - Protected with AdminRouteGuard */}
      <Route path="/dashboard/*" element={
        <AdminRouteGuard>
          <DashboardProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/customers" element={<Registrations />} />
                <Route path="/referrals" element={<ReferralApprovals />} />
                <Route path="/tenants" element={<Tenants />} />
                <Route path="/rag-config" element={<RagConfig />} />
                <Route path="/admin-users" element={<AdminUsers />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/trial-reminders" element={<TrialReminders />} />
                <Route path="/multilingual" element={<Multilingual />} />
                <Route path="/handover" element={<AdminHandover />} />
                <Route path="/system-monitor" element={<SystemMonitor />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Layout>
          </DashboardProvider>
        </AdminRouteGuard>
      } />
      </Routes>
    </>
  )
}

export default App